<!-- <div class="mx-3"> -->
    <div class="row m-0 pb-3">
        <app-sinclair-cards class="p-0 d-block w-100" [cards]="sinclairCards" (filterChanged)="loadAllComponents()" (filtersClicked)="cardFiltersClicked($event)"></app-sinclair-cards>
    </div>

    <div class="row m-0 pb-3">
        <app-statistics-chart class="p-0 d-block w-100" [dgeId]="dgeId"></app-statistics-chart>
    </div>

    <div class="row m-0 pb-3">
        <div class="col-12 pe-2">
            @if (cardsInfo.length === 4) {
                <div class="row m-0 p-0">
                    <div class="px-0 col-6 pe-3">
                        <div class="row m-0 p-0">
                            <div class="col-6 ps-0 pe-2">
                                <div class="p-3 pb-2 bg-dpwhite border border-dpgray300 h-100" style="border-radius: 5px;">
                                    <div class="d-flex justify-content-between align-items-baseline">
                                        <h6 class="widget-title text-truncate pe-1">{{ cardsInfo[0].text | translate }}</h6>
                                        <h5 class="widget-info text-truncate">{{ cardsInfo[0].value }}</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6 ps-2 pe-0">
                                <div class="p-3 pb-2 bg-dpwhite border border-dpgray300 h-100" style="border-radius: 5px;">
                                    <div class="d-flex justify-content-between align-items-baseline">
                                        <h6 class="widget-title text-truncate pe-1">{{ cardsInfo[1].text | translate }}</h6>
                                        <h5 class="widget-info text-truncate">{{ cardsInfo[1].value }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="px-0 col-6">
                        <div class="row m-0 p-0">
                            <div class="col-6 ps-0 pe-2">
                                <div class="p-3 pb-2 bg-dpwhite border border-dpgray300 h-100" style="border-radius: 5px;">
                                    <div class="d-flex justify-content-between align-items-baseline">
                                        <h6 class="widget-title text-truncate pe-1">{{ cardsInfo[2].text | translate }}</h6>
                                        <h5 class="widget-info text-truncate">{{ cardsInfo[2].value }}</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6 ps-2 pe-0">
                                <div class="p-3 pb-2 bg-dpwhite border border-dpgray300 h-100" style="border-radius: 5px;">
                                    <div class="d-flex justify-content-between align-items-baseline">
                                        <h6 class="widget-title text-truncate pe-1">{{ cardsInfo[3].text | translate }}</h6>
                                        <h5 class="widget-info text-truncate" [class]="cardsInfo[3].customStylesValue.cssClass">{{ cardsInfo[3].value }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>

    <div class="row m-0 pb-3">
        <div class="col-12 pe-2">
            <app-statistics-header class="col-12" [jobs]="selectedRow"
                (filtersChanged)="onFilterChange($event)"
                (columnVisibilityChanged)="onColumnVisibilityChange($event)">
            </app-statistics-header>

            <app-statistics-table (selectedRow)="onCheckChange()"
                                (tableLoaded)="onTableLoaded($event)"
                                [dgeId]="dgeId"
                                [filters]="filters"
                                class="col-12">
            </app-statistics-table>
        </div>
    </div>
<!-- </div> -->